<template>
	<main>
		<div class="py-12">
			<div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
				<h1
					class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate"
				>
					Verkürzung
					{{ update == false ? "erstellen" : "bearbeiten" }}
				</h1>
				<div
					class="bg-white overflow-hidden shadow-xl sm:rounded-lg mt-6"
				>
					<div class="px-6 py-4">
						<form @submit.prevent="submit()">
							<div class="grid grid-cols-6 gap-6">
								<div class="col-span-6 sm:col-span-6">
									<form-label
										for="title"
										value="Titel *"
									></form-label>
									<form-input
										id="title"
										type="input"
										class="mt-1 block w-full"
										v-model="data.title"
										autofocus
									></form-input>
									<error-field
										:message="errors.title"
										v-if="errors.title"
									/>
								</div>
								<div
									class="col-span-6 sm:col-span-6"
									v-if="update == true"
								>
									<form-label
										for="link"
										value="Erzeugter Link"
									></form-label>
									<p id="link" class="mt-1 w-full">
										{{ data.link }}
									</p>
								</div>
								<div
									class="col-span-6 sm:col-span-6"
									v-if="update == false"
								>
									<form-label
										for="domain_id"
										value="Domain *"
									></form-label>
									<form-input
										id="domain_id"
										type="select"
										:options="domainOptions"
										class="mt-1 block w-full"
										v-model="data.domain_id"
										autofocus
									></form-input>
									<error-field
										:message="errors.domain_id"
										v-if="errors.domain_id"
									/>
								</div>
								<div
									class="col-span-6 sm:col-span-6"
									v-if="update == false"
								>
									<form-label
										for="url_type"
										value="Typ *"
									></form-label>
									<form-input
										id="url_type"
										type="select"
										:options="[
											{
												value: 0,
												label:
													'automatische Verkürzung',
											},
											{
												value: 1,
												label: 'eigene Verkürzung',
											},
										]"
										class="mt-1 block w-full"
										v-model="data.url_type"
										autofocus
									></form-input>
								</div>
								<div
									class="col-span-6 sm:col-span-6"
									v-if="update == false && data.url_type == 1"
								>
									<form-label
										for="slug"
										value="Verkürzung *"
									></form-label>
									<form-input
										id="slug"
										type="input"
										class="mt-1 block w-full"
										v-model="data.slug"
										@keyup="checkSlug"
										autofocus
									></form-input>
									<error-field
										:message="errors.slug"
										v-if="errors.slug"
									/>
								</div>
								<div class="col-span-6 sm:col-span-6">
									<form-label
										for="target_url"
										value="Ziel-URL *"
									></form-label>
									<form-input
										id="target_url"
										type="input"
										class="mt-1 block w-full"
										v-model="data.target_url"
										autofocus
									></form-input>
									<error-field
										:message="errors.target_url"
										v-if="errors.target_url"
									/>
								</div>
								<div class="col-span-6 sm:col-span-6">
									<form-label
										for="description"
										value="Beschreibung"
									></form-label>
									<form-input
										id="description"
										type="textarea"
										class="mt-1 block w-full"
										v-model="data.description"
										autofocus
									></form-input>
								</div>
							</div>
						</form>
					</div>
					<div class="px-6 py-4 bg-gray-100 text-right">
						<form-button
							:type="button"
							button="secondary"
							class="ml-2"
							@click="this.$router.push('/url/overview')"
						>
							Zurück zur Übersicht
						</form-button>

						<form-button
							:type="submit"
							class="ml-2"
							@click="submit()"
						>
							Speichern
						</form-button>
					</div>
				</div>
			</div>
		</div>
	</main>
</template>

<script>
	import UrlService from "@/services/url.js";
	import DomainService from "@/services/domain.js";
	import { useRoute } from "vue-router";
	import FormLabel from "@/components/FormLabel";
	import FormInput from "@/components/FormInput";
	import FormButton from "@/components/FormButton";
	import ErrorField from "@/components/ErrorField";

	export default {
		components: {
			FormLabel,
			FormInput,
			FormButton,
			ErrorField,
		},
		data() {
			return {
				errors: {},
				old_target_url: null,
				timer: null,
				data: {
					title: null,
					url_type: 0,
					description: null,
					target_url: null,
					slug: null,
					domain_id: 0,
					node_id: this.$store.getters.getUser.node_id,
					external_id: this.$store.getters.getUser.id,
					username: this.$store.getters.getUser.username,
					creator_id: this.$store.getters.getUser.imperia_id,
					external: 1
				},
				domainOptions: [],
			};
		},
		props: ["update"],
		async created() {
			if (this.update) {
				const route = useRoute();
				this.readUrl(route.params.id);
			} else {
				this.getDomains();
			}
		},
		methods: {
			submit() {
				let _this = this;

				_this.$emit("update-loading-overlay", true);

				_this.errors = {};

				if (!_this.update) {
					if (_this.data.url_type == 1) {
						if (
							_this.data.slug == null ||
							_this.data.slug.trim() == ""
						) {
							_this.errors.slug =
								"Die Angabe der eigenen Verkürzung ist erforderlich";
						} else {
							var regex = new RegExp("^([a-zA-Z0-9 _-]+)$", "is");
							if (!_this.data.slug.match(regex)) {
								_this.errors.slug =
									"Die Verkürzung darf nur Klein- und Großbuchstaben, Zahlen und die Zeichen _- enthalten";
							}
						}
					}

					if (
						_this.data.title == null ||
						_this.data.title.trim() == ""
					) {
						_this.errors.title =
							"Die Angabe eines Titels ist erforderlich";
					}

					let urlRegex = new RegExp(
						"^https?:\/\/([^?#]*)(\\?([^#]*))?(#(.*))?"
						// "^((http|https)://)(www.)?[a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)$",
						// "is"
					);
					if (
						_this.data.target_url == null ||
						!_this.data.target_url.match(urlRegex)
					) {
						_this.errors.target_url =
							"Die Ziel-URL hat kein richtiges URL-Format";
					}

					if (Object.keys(_this.errors).length > 0) {
						_this.$emit("update-loading-overlay", false);
						return;
					}

					let payload = {
						domain_id: _this.data.domain_id,
						slug: _this.data.slug,
						url_type: _this.data.url_type,
						superuser: 0,
						node_id: _this.$store.getters.getUser.node_id,
						accessible_nodes: [
							_this.$store.getters.getUser.node_id,
						],
						title: _this.data.title,
						update: _this.update
					};

					UrlService.check(payload)
						.then((response) => {
							if (response.success) {
								UrlService.create(_this.data)
									.then((response) => {
										if (response.success) {
											_this.$emit("show-toast", {
												message:
													"Verkürzung erfolgreich erstellt!",
												type: "success",
											});

											_this.$router.push(
												"/url/read/" + response.url_id
											);
										} else {
											_this.$emit(
												"update-loading-overlay",
												false
											);
											_this.$emit("show-toast", {
												message: response.message,
												type: "error",
											});
										}
									})
									.catch((error) => {
										_this.$emit(
											"update-loading-overlay",
											false
										);
										console.log(error);
									});
							} else {
								_this.errors = response.errors;

								_this.$emit("show-toast", {
									message:
										"Bitte überprüfen Sie Ihre Angaben!",
									type: "error",
								});
								_this.$emit("update-loading-overlay", false);
							}
						})
						.catch((error) => {
							_this.$emit("update-loading-overlay", false);

							_this.$emit("show-toast", {
								message: error,
								type: "error",
							});
						});
				} else {
					if (_this.data.url_type == 1) {
						if (
							_this.data.slug == null ||
							_this.data.slug.trim() == ""
						) {
							_this.errors.slug =
								"Die Angabe der eigenen Verkürzung ist erforderlich";
						} else {
							var regex = new RegExp("^([a-zA-Z0-9 _-]+)$", "is");
							if (!_this.data.slug.match(regex)) {
								_this.errors.slug =
									"Die Verkürzung darf nur Klein- und Großbuchstaben, Zahlen und die Zeichen _- enthalten";
							}
						}
					}

					let urlRegex = new RegExp(
						"^https:\/\/([^?#]*)(\\?([^#]*))?(#(.*))?",
						"is"
					);
					if (
						_this.data.target_url == null ||
						!_this.data.target_url.match(urlRegex)
					) {
						_this.errors.target_url =
							"Die Ziel-URL hat kein richtiges URL-Format";
					}

					if (Object.keys(_this.errors).length > 0) {
						_this.$emit("update-loading-overlay", false);
						return;
					}

					let payload = {
						domain_id: _this.data.domain_id,
						slug: _this.data.slug,
						url_type: _this.data.url_type,
						superuser: 0,
						node_id: _this.$store.getters.getUser.node_id,
						accessible_nodes: [
							_this.$store.getters.getUser.node_id,
						],
						title: _this.data.title,
						update: _this.update,
					};

					UrlService.check(payload)
						.then((response) => {
							if (response.success) {
								let updatePayload = {
									description: _this.data.description,
									node_id:
										_this.$store.getters.getUser.node_id,
									title: _this.data.title,
									target_url: _this.data.target_url,
									old_target_url: _this.old_target_url,
									id: _this.data.id,
									external_id: _this.$store.getters.getUser.id,
									imperia_id: _this.$store.getters.getUser.imperia_id,
									username: _this.$store.getters.getUser.username,
									external: 1,
								};

								UrlService.update(updatePayload)
									.then((response) => {
										if (response.success) {
											_this.$emit("show-toast", {
												message:
													"Verkürzung erfolgreich bearbeitet!",
												type: "success",
											});
											_this.$router.push(
												"/url/read/" + _this.data.id
											);
										} else {
											_this.$emit(
												"update-loading-overlay",
												false
											);
											_this.$emit("show-toast", {
												message: response.message,
												type: "error",
											});
										}
									})
									.catch((error) => {
										_this.$emit(
											"update-loading-overlay",
											false
										);
										_this.$emit("show-toast", {
											message: error,
											type: "error",
										});
									});
							} else {
								_this.errors = response.errors;

								_this.$emit("show-toast", {
									message:
										"Bitte überprüfen Sie Ihre Angaben!",
									type: "error",
								});
								_this.$emit("update-loading-overlay", false);
							}
						})
						.catch((error) => {
							_this.$emit("update-loading-overlay", false);

							_this.$emit("show-toast", {
								message: error,
								type: "error",
							});
						});
				}
			},
			readUrl(id) {
				let _this = this;

				_this.$emit("update-loading-overlay", true);

				UrlService.read({
					id: id,
				})
					.then((response) => {
						_this.data = response.data;
						_this.old_target_url = _this.data.target_url;
						_this.$emit("update-loading-overlay", false);
					})
					.catch((error) => {
						_this.$emit("update-loading-overlay", false);

						_this.$emit("show-toast", {
							message: error,
							type: "error",
						});
					});
			},
			checkSlug() {
				let _this = this;
				if (this.timer) {
					clearTimeout(this.timer);
					this.timer = null;
				}

				this.timer = setTimeout(function() {
					if (_this.data.slug.trim() == "") {
						_this.errors.slug =
							"Die Angabe der eigenen Verkürzung ist erforderlich";
					} else {
						let newData = {
							domain_id: _this.data.domain_id,
							slug: _this.data.slug,
						};

						UrlService.checkSlug(newData).then((response) => {
							if (response.success == 0) {
								for (var key in response.errors) {
									_this.errors[key] = response.errors[key];
								}
							} else {
								_this.errors.domain_id = null;
								_this.errors.slug = null;
							}
						});
					}
				}, 250);
			},
			getDomains() {
				let _this = this;

				_this.$emit("update-loading-overlay", true);

				DomainService.overview()
					.then((response) => {
						let user = _this.$store.getters.getUser;
						_this.domainOptions = response.data
							.filter((obj) => {
								let nodeIds = obj["node_ids"].split(",");
								return nodeIds.includes(user.node_id);
							})
							.map((obj) => {
								return {
									value: obj.id,
									label: obj.domain,
								};
							});

						_this.data.domain_id = _this.domainOptions[0].value;
						_this.$emit("update-loading-overlay", false);
					})
					.catch((error) => {
						_this.$emit("update-loading-overlay", false);

						_this.$emit("show-toast", {
							message: error,
							type: "error",
						});
					});
			},
		},
	};
</script>
